import React from 'react';
import {
    BarLabel,
    RedBar,
    YellowBar,
    Title,
    GreenBar,
    IndicatorPointer,
    IndicatorLabel,
} from '../details/styledComponents';

import { SxProps } from '@mui/material/styles';
import Stack from '@mui/material/Stack';

import {
    SCORE_DIVISIONS,
    getBoundedScore,
    getScoreColor,
    getScoreRange,
} from 'ff/debrief/utils';

interface Props {
    score?: number;
    sx?: SxProps;
}

const OverallScoreBar: React.FC<Props> = props => {
    const { red, yellow, green } = SCORE_DIVISIONS;
    const boundedScore = getBoundedScore(props.score);
    const scoreColor = getScoreColor(props.score);
    const [redStart, redEnd] = getScoreRange('red');
    const [yellowStart, yellowEnd] = getScoreRange('yellow');
    const [greenStart, greenEnd] = getScoreRange('green');
    const redWidth = Math.abs(redStart - redEnd);
    const yellowWidth = Math.abs(yellowStart - yellowEnd);
    const greenWidth = Math.abs(greenStart - greenEnd);

    return (
        <Stack px={1} sx={props.sx}>
            <Title>Overall Score</Title>
            <Stack position="relative" direction="row" width="100%">
                <RedBar bgcolor={red.color} width={`${redWidth}%`}>
                    <BarLabel>
                        {redStart}-{redEnd - 1}
                    </BarLabel>
                </RedBar>
                <YellowBar bgcolor={yellow.color} width={`${yellowWidth}%`}>
                    <BarLabel>
                        {yellowStart}-{yellowEnd - 1}
                    </BarLabel>
                </YellowBar>
                <GreenBar bgcolor={green.color} width={`${greenWidth}%`}>
                    <BarLabel>
                        {greenStart}-{greenEnd}
                    </BarLabel>
                </GreenBar>
                <IndicatorPointer
                    bgcolor={scoreColor}
                    left={`${Math.min(boundedScore, 98)}%`}
                >
                    <IndicatorLabel>{boundedScore}</IndicatorLabel>
                </IndicatorPointer>
            </Stack>
        </Stack>
    );
};

export default OverallScoreBar;
